export enum AccountFeatureFlags {
  ABTestPlayingInsightsProfitLoss = 'abtest_playing_insights_profitloss',
  AMLLoginMsg = 'aml-login-msg',
  AMLLoginMsgVerified = 'aml-login-msg-verified',
  AccountChangeMobile = 'account_change_mobile',
  AccountCreatedContinue = 'AccountCreatedContinue',
  AccountMenuAddressSearch = 'acc-menu-address-search',
  AddressUpdateDisabled = 'address-update-disabled',
  BELoginExistingUsers = 'be-login-existing-users',
  BELoginSuspendedUsers = 'be-login-suspended-users',
  BGLoginExistingUsers = 'bg-login-existing-users',
  BGLoginSuspendedUsers = 'bg-login-suspended-users',
  CapmodPlayerHandHistoryEnabled = 'capmod-player-hand-history-enabled',
  CommlibProxy = 'CommlibProxy',
  CrossOperatorInactiveStatus = 'CrossOperatorInactiveStatus',
  CustomPIN = 'custom-pin',
  DELossLimit = 'DE_losslimit',
  DESpendLimit = 'DE_SpendLimit',
  DarkModeEnabled = 'dark_mode_enabled',
  DarkModeSettingEnabled = 'dark_mode_setting_enabled',
  DocumentsRequestPrompt = 'document_request_prompt',
  EELoginExistingUsers = 'ee-login-existing-users',
  ESActivitySummaryReport = 'ES_ActivitySummaryReport',
  ESportsBookAuth = 'eSportsBookAuth',
  EnableCOMSelfExclusionExtension = 'EnableCOMSelfExclusionExtension',
  EnableESFixedDepositLimitValidity = 'EnableESFixedDepositLimitValidity',
  EnableNotificationServiceGQLSubscription = 'EnableNotificationServiceGQLSubscription',
  EnableServerDepositLimitsDK = 'enableServerDepositLimitsDK',
  EuDeOasisStreetAddress = 'EUDE_Oasis_Street_Address',
  FeedbackVerification = 'feedback-csat-verification',
  FreemiumMobile = 'eFreemiumMobile',
  HandHistoryRAMMyHandHistoryRequests = 'HandHistory_RAM_MyHandHistoryRequests',
  HideEmailConfirmationCode = 'hideEmailConfirmationCode',
  HideOneTimePinMenu = 'hideOneTimePinMenu',
  HideRsaTokenMenu = 'hideRsaTokenMenu',
  HideStarsPinMenu = 'hideStarsPinMenu',
  IDScanHosted = 'IDScan-Hosted',
  MultiCurrency = 'multi-currency',
  NoCasinoGameHistory = 'noCasinoGameHistory',
  NoLanguages = 'noLanguages',
  PublicLiveChatSupport = 'ePublicLiveChatSupport',
  RGLugasDepositLimit = 'RGLugasDepositLimit',
  RestrictSeWeeklyLimit = 'restrict-se-weekly-limit',
  SelfExclusionNewDesign = 'SelfExclusionNewDesign',
  ShowUKSpendBudgetMenu = 'ShowUKSpendBudgetMenu',
  SignUpShowState = 'SignUpShowState',
  SportsBookLimits = 'eSportsBookLimits',
  SportsBookNonAuth = 'eSportsBookNonAuth',
  SportsBookOptions = 'eSportsBookOptions',
  SuspendUsersVerification = 'suspended-users-verification',
  SwcFetchVipPoints = 'swc-fetch-vip-points',
  TemporaryLoginTimeLimit = 'temporaryLoginTimeLimit',
  TwitchConnect = 'TwitchConnect',
  Under25SwedishPlayers = 'under_25_swedish_players',
  UseWC2ResolverTags = 'useWC2ResolverTags',
  VerificationRMOKCheck = 'docverify-check-rmok',
  VerifyDocFallback = 'verify-doc-fallback',
  VisibilityPlayingInsights = 'Visibility_Playing_Insights',
  VisibilityPlayingInsightsLoginPopup = 'Visibility_Playing_Insights_Login_popup',
  VisibilityRestrictWithdrawalCancellation = 'visibility_restrict_withdrawal_cancellation'
}
